angular.module('unergie.main')
.controller('promoCategoriesModalCtrl', ($scope, $uibModalInstance, DataAccessRefPromo, AlertManager, NgTableParams, ErrorCatcher) => {
    $scope.refresh = () =>
        DataAccessRefPromo.getPromoCategories().$promise.then((data) => {
            $scope.tableParams = new NgTableParams({}, { dataset: data })
        }).catch(ErrorCatcher)

    $scope.refresh()

    $scope.editCategoryTemplate = { name: '' }

    $scope.editCategoryFields = {
        name: {
            label: 'Nouveau nom',
            type: 'text',
            forceUppercase: true,
            required: true,
        },
    }

    $scope.deleteCategory = (category) => {
        category.deleting = true
        return DataAccessRefPromo.delPromoCategory({ id: category.id }).$promise.then(() => {
            AlertManager.success('Catégories supprimée')
            $scope.refresh()
        }).catch(ErrorCatcher)
        .finally(() => {
            category.deleting = false
        })
    }

    $scope.addCategory = () => {
        if (!$scope.newCategory) {
            return
        }
        $scope.adding = true
        return DataAccessRefPromo.postPromoCategory({ name: $scope.newCategory.toUpperCase() }).$promise.then(() => {
            $scope.newCategory = ''
            AlertManager.success('Catégories ajoutée')
            $scope.refresh()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.adding = false
        })
    }


    $scope.renameCategory = (category) => {
        category.renaming = true
        return DataAccessRefPromo.putPromoCategory({ id: category.id }, { name: $scope.editCategoryTemplate.name.toUpperCase() }).$promise.then(() => {
            AlertManager.success('Catégories mise à jour')
            $scope.refresh()
        }).catch(ErrorCatcher)
        .finally(() => {
            category.renaming = false
        })
    }

    $scope.ok = () => $uibModalInstance.close()
})
